export default class PopUp {
  constructor(element) {
   this.trigger = element.querySelector('.js-pop-up-trigger');
   this.target = element.querySelector('.js-pop-up-target');
	// Add js to the classes below for the cross and background
	// corss is not general enough what if its nolonger a cross
	this.cross = element.querySelector('.pop-up__cross-icon');
	this.background = element.querySelector('.pop-up__bg');
	// this.sliderImg = element.querySelector('.slider-item__img');
	// this.sliderVid = element.querySelector('.plyr__poster');


    this.init();
  }


  init() {


	this.background.addEventListener('click', () => {
		this.target.classList.toggle('pop-up--hidden');
		});

	 this.cross.addEventListener('click', () => {
		this.target.classList.toggle('pop-up--hidden');
		});

    this.trigger.addEventListener('click', () => {
      this.target.classList.toggle('pop-up--hidden');
    });
  }
}
